require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-applied-accessibility-make-screen-reader-navigation-easier-with-the-header-landmark.json") })
        }
      }, "path---responsive-web-design-applied-accessibility-make-screen-reader-navigation-easier-with-the-header-landmark");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-applied-accessibility-make-screen-reader-navigation-easier-with-the-header-landmark!./.cache/json/responsive-web-design-applied-accessibility-make-screen-reader-navigation-easier-with-the-header-landmark.json
// module id = 2516
// module chunks = 231608221292675